import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  TableSettings,
  TableSpacing,
} from 'src/app/components/pagination/pagination.component';
import { Product, ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit {
  allProducts: Product[] = [];
  loading = false;

  showInactiveProducts = false;

  searchText = '';

  pageSize = 15;
  currentPage = 1;

  pageSizeOptions = [10, 15, 20, 50, 100];

  spacingOptions = ['compact', 'normal', 'comfortable'];
  spacing: TableSpacing = 'normal';

  constructor(
    private route: ActivatedRoute,
    private productsService: ProductsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadSettings();
    this.getProducts();
    this.loadQueryParams();
  }

  get totalPages() {
    return Math.ceil(this.displayProducts.length / this.pageSize);
  }

  loadSettings() {
    try {
      const settings = localStorage.getItem('productTableSettings');
      if (settings) {
        const parsed = JSON.parse(settings);
        this.pageSize = Number(parsed.pageSize);
        this.spacing = parsed.spacing;
      }
    } catch (err) {
      console.error(err as Error);
    }
  }

  loadQueryParams() {
    this.route.queryParams.subscribe((params) => {
      this.showInactiveProducts = params['showInactiveProducts'] === 'true';
      this.searchText = params['searchText'] ?? '';
    });
  }

  getProducts() {
    if (this.loading) return;
    this.loading = true;

    this.productsService.getAllProducts().subscribe({
      next: (res) => {
        console.log('res: ', res);
        if (res) {
          this.allProducts = res.products;
          this.allProducts.sort((a, b) => {
            if (a.code < b.code) return -1;
            if (a.code > b.code) return 1;
            return 0;
          });
        } else {
          console.error(new Error('No products returned from server'));
          console.log('res: ', res);
          this.allProducts = [];
        }
      },
      error: (err) => {
        console.error(new Error('Error getting products from server'));
        console.log('err: ', err);
        this.allProducts = [];
      },
      complete: () => {
        console.log('ProductListComponent getProducts complete');
        this.loading = false;
      },
    });
  }

  get displayProducts() {
    let products = this.allProducts;

    if (!this.showInactiveProducts) {
      products = products.filter((product) => product.active);
    }

    if (this.searchText.trim() === '') {
      return products;
    }

    const s = this.searchText.toLowerCase();
    return products.filter(
      (product) =>
        product.title.toLowerCase().includes(s) ||
        product.description.toLowerCase().includes(s) ||
        product.code.toLowerCase().includes(s) ||
        product.type.toLowerCase().includes(s)
    );
  }

  get currentPageProducts() {
    const offset = (this.currentPage - 1) * this.pageSize;
    return this.displayProducts.slice(offset, offset + this.pageSize);
  }

  navigateToProductDetails(product: Product) {
    console.log('navigateToProductDetails');
    console.log('product: ', product);
    this.router.navigate([`admin/product/${product.id}`]);
  }

  updateQueryParams() {
    this.currentPage = 1;
    this.router.navigate([], {
      queryParams: {
        showInactiveProducts: this.showInactiveProducts ? 'true' : null,
        searchText:
          this.searchText.trim() !== '' ? this.searchText.trim() : null,
      },
      queryParamsHandling: 'merge',
    });
  }

  handleSettingsChanged(settings: TableSettings) {
    console.log('handleSettingsChanged: ', settings);
    this.pageSize = Number(settings.pageSize);
    this.spacing = settings.spacing;
    // this.updateCurrentPageProducts();
    const newSettings = {
      pageSize: Number(settings.pageSize),
      spacing: settings.spacing,
    };
    localStorage.setItem('productTableSettings', JSON.stringify(newSettings));
  }
}
